
export default {
    name: 'ProductsSearchCard',
    props: {
        url: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: '',
        },
        primaryImageUrl: {
            type: String,
            default: '',
        },
        stockNumber: {
            type: String,
            default: '',
        },
        displayName: {
            type: String,
            default: '',
        },
        additionalDisplayName: {
            type: String,
            default: '',
        },
        translations: {
            type: Object,
            default: {},
        },
    },
    computed: {
        stockOrProducts() {
            return this.stockNumber ? this.stockNumber : this.translations?.Products;
        },
    },
};
